var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcShieldTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3605 2.74786L8.69385 1.37453C8.31385 1.23453 7.69385 1.23453 7.31385 1.37453L3.64719 2.74786C2.94052 3.01453 2.36719 3.8412 2.36719 4.59453V9.99453C2.36719 10.5345 2.72052 11.2479 3.15385 11.5679L6.82052 14.3079C7.46719 14.7945 8.52719 14.7945 9.17385 14.3079L12.8405 11.5679C13.2739 11.2412 13.6272 10.5345 13.6272 9.99453V4.59453C13.6339 3.8412 13.0605 3.01453 12.3605 2.74786ZM10.3205 6.4812L7.45385 9.34786C7.35385 9.44786 7.22719 9.49453 7.10052 9.49453C6.97385 9.49453 6.84719 9.44786 6.74719 9.34786L5.68052 8.26786C5.48719 8.07453 5.48719 7.75453 5.68052 7.5612C5.87385 7.36786 6.19385 7.36786 6.38719 7.5612L7.10719 8.2812L9.62052 5.76786C9.81385 5.57453 10.1339 5.57453 10.3272 5.76786C10.5205 5.9612 10.5205 6.28786 10.3205 6.4812Z",
    fill: "#9091A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShieldTick);
export default __webpack_public_path__ + "static/media/ic-shield-tick.0f8f3a7b851166f12094ca13514c7ffa.svg";
export { ForwardRef as ReactComponent };